module.exports = __webpack_public_path__ + "static/media/planning-for-success-large.fe3e5f3e.png";